<template>
    <div class="row">
        <div class="col-md-12 mb-2">
            <div class="bsp-purple">
                <div class="row mb-1"> 
                    <div class="col-md-auto">{{ data[0]?.Tahun ?? (selectedyears[0] ?? '-') }}</div> 
                    <div class="col"><span class="text-center w-100" style="font-size:10px;">{{ title }}</span></div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="d-flex align-items-center mb-2 ms-1"><i class="fa fa-bullseye bsp-icon-purple me-3"></i> <div class="w-100 text-right">Rp. {{ formatNum(data[0]?.TargetNettSales ?? 0) }}</div></div>
                        <div class="d-flex align-items-center mb-1"><i class="fas fa-shopping-cart bsp-icon-purple me-3"></i> <div class="w-100 text-right">Rp. {{ formatNum(data[0]?.NettSales ?? 0) }}</div></div>
                    </div>
                    <div class="col-md-auto text-center ps-2 me-2 mt-1">
                        <div>{{ formatNum(((data[0]?.NettSales ?? 0)/(data[0]?.TargetNettSales ?? 0)) * 100) }}%</div>
                        <div><i class="fa fa-line-chart bsp-icon-purple"></i></div>
                    </div>										
                </div>
                <div class="text-center">NET SALES (M IDR)</div>
            </div>
            <Loader v-if="loading" />
        </div>

        <div class="col-md-12">
            <div class="bsp-purple">
                <div class="row mb-2"> 
                    <div class="col-md-auto">{{ data[1]?.Tahun ?? (selectedyears[1] ?? '-') }}</div> 
                    <div class="col"><span class="text-center w-100" style="font-size:10px;"></span></div>
                </div>
                <div class="row">
                    <div class="col">
                        <!--<div class="d-flex align-items-center mb-2 ms-1"><i class="fa fa-bullseye bsp-icon-purple me-3"></i> <div class="w-100 text-right">Rp. {{ formatNum(data[1].TargetNettSales) }}</div></div>-->
                        <div class="d-flex align-items-center mb-1"><i class="fas fa-shopping-cart bsp-icon-purple me-3"></i> <div class="w-100 text-right">Rp. {{ formatNum(data[1]?.NettSales ?? 0) }}</div></div>
                    </div>
                    <div class="col-md-auto text-center ps-2 me-2 mt-0">
                        <div>{{ formatNum((((data[0]?.NettSales ?? 0)-(data[1]?.NettSales ?? 0))/(data[1]?.NettSales ?? 0)) * 100) }}%</div>
                        <div><i class="fa fa-line-chart bsp-icon-purple"></i></div>
                    </div>										
                </div>
                <div class="text-center">GROWTH {{ data[0]?.Tahun ?? (selectedyears[0] ?? '-') }} THD {{ data[1]?.Tahun ?? (selectedyears[1] ?? '-') }}</div>
            </div>
            <Loader v-if="loading" />
        </div>
    </div>
</template>


<script>
import BarCard from '@/views/pages/BarCard.vue'
import ListItem from '@/views/pages/ListItem.vue'
import ListCompare from '@/views/pages/ListCompare.vue'
import Fuel from '@/components/page/Fuel.js'
import Footer from '@/views/Footer.vue'
import PieChart from '@/components/chart/Pie.js'
import { Rainbow, Rainbow3, Penanggalan, AppColors, Config, AxiosWithJar } from '@/utility.js'
import Loader from '@/components/loader/Loader2.vue'

export default{
	extends: Fuel,
	components:{
		Loader,
		//ListItem,
		//ListCompare,
		//BarCard,
		//PieChart,
		//Footer            
	},
	props: {
        title: {
            type: String,
            default: 'NET SALES',
            //required: false,
        },
        year: {
            type: String,
            default: '2024',
            //required: false,
        },
        area: {
            type: String,
            default: '',
            //required: false,
        },
        amount :{
            type: String,
            default: '0',
            //required: false,
        },
        years: {
            type: Array,
            default: () => ['2024'],
            //required: false,
        },
        data: {
			type: Array,
			default: () => []
		},
        loading: {
            type: Boolean,
            default: false,
        },
    },
	data() {
		return {
            selectedyears : this.years.slice().sort((a, b) => b - a), //this.years,
			reportdata: [],
            value: 0,
            /*
			loading: {
				table: false,
				chart: false,
			},
            */
		}
	},
	watch: {
        years: {
            handler(newVal) {
                this.selectedyears = newVal.slice().sort((a, b) => b - a);
            },
            immediate: true,
            deep: true
        }
	}, 
	computed: {
        /*
		totalOutstanding() {
			return this.reportdata.data.reduce((sum, item) => sum + item.Count, 0);
		},
        */
	},

    mounted() {
		//this.getData();
    },
    methods:{
		
	}
}
</script>


<style>
.bsp-purple {
	background-color: #D6DCE5; 
	border-radius:6px; 
	border-left: 20px solid #7030A0;
	padding: 6px 8px;
	color: #7030A0;
	font-weight: bold;
}

.bsp-icon-purple {
	font-size:30px;
}

.text-ellipsis {
    white-space: nowrap;         /* Mencegah teks membungkus ke baris berikutnya */
    overflow: hidden;            /* Menyembunyikan teks yang melebihi lebar kontainer */
    text-overflow: ellipsis;
}
</style>